import React, { useEffect } from 'react'
import "../specially/specially.css"
import fstartups from "../../images/fs.jpg"
import fagencies from "../../images/fag.jpg"
import fsme from "../../images/fsme.jpg"
import { FaArrowRightLong } from "react-icons/fa6";
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styless

function Specially() {
    useEffect(() => {
        AOS.init(); // Initialize AOS
    }, []);
    return (
        <section className='specially-main'>
            <div className="left">
                <div className="specially-card1 forstartupcard" data-aos="flip-left">
                    <img className='spcardimg' src={fstartups}  alt="" />
                    <div className="specialycard-inner">
                        <p className='sp-t1'>Specially</p>
                        <h2 className='sp-t2'>For Startups</h2>
                        <a className='speciallycardlink' href="https://arttteo.com/expertise/for-startup">
                            <button className="estimation-button">
                                <p>Learn More</p>
                                <div className="arrow-circle">
                                    <FaArrowRightLong />
                                </div>
                            </button>
                        </a>
                    </div>
                </div>

                <div className="specially-card1 foragenciescard" data-aos="flip-left">
                    <img className='spcardimg' src={fagencies} alt="" />
                    <div className="specialycard-inner">
                        <p className='sp-t1'>Specially</p>
                        <h2 className='sp-t2'>For Agencies</h2>
                        <a className='speciallycardlink' href="https://arttteo.com/expertise/for-investors">
                            <button className="estimation-button">
                                <p>Learn More</p>
                                <div className="arrow-circle">
                                    <FaArrowRightLong />
                                </div>
                            </button>
                        </a>
                    </div>
                </div>

            </div>

            <div className="specially-card2 forsmecard" data-aos="flip-right">
                <img className='spcardimg' src={fsme} alt="" />
                <div className="specialycard-inner">
                    <p className='sp-t1'>Specially</p>
                    <h2 className='sp-t2'>For SME</h2>
                    <a className='speciallycardlink' href="https://arttteo.com/expertise/for-programs">
                        <button className="estimation-button">
                            <p>Learn More</p>
                            <div className="arrow-circle">
                                <FaArrowRightLong />
                            </div>
                        </button>
                    </a>
                </div>
            </div>


        </section>
    )
}

export default Specially